import { openAPIClient } from '../openApiClient';
import type {
  GetActivityListServiceConfig,
  GetRunningResourceActivitiesServiceConfig,
  RunningResourceActivitiesResponse,
  UserActivityListResponse,
} from './types/index';

/**
 * Get a paginated list of user activities
 */
export async function getActivityListService({
  httpRequestConfig,
  params,
}: GetActivityListServiceConfig): Promise<UserActivityListResponse> {
  const client = await openAPIClient(httpRequestConfig);

  if (params === undefined) {
    throw new Error('Params are required');
  }

  const response = await client.GET('/v1/auth/userActivity/{id}', {
    params: {
      path: {
        id: params.params.id,
      },
      query: {
        sortByField: params.query?.sortByField ?? 'startedAt',
        sortByOrder: params.query?.sortByOrder ?? 'desc',
        paginationFirst: params.query?.paginationFirst,
        paginationAfter: params.query?.paginationAfter,
        paginationLast: params.query?.paginationLast,
        paginationBefore: params.query?.paginationBefore,
        searchTerm: params.query?.searchTerm,
        filters: params.query?.filters,
        searchByType: params.query?.searchByType,
      },
    },
  });

  if (response.error !== undefined) {
    throw new Error(response.error.message);
  }

  return response.data;
}

/**
 * Get running activities for a specific resource
 */
export async function getRunningResourceActivitiesService({
  httpRequestConfig,
  params,
}: GetRunningResourceActivitiesServiceConfig): Promise<RunningResourceActivitiesResponse> {
  const client = await openAPIClient(httpRequestConfig);

  if (params === undefined) {
    throw new Error('Params are required');
  }

  const response = await client.GET('/v1/auth/userActivity/{id}/runningResourceActivities/{spaceId}', {
    params: {
      path: {
        id: params.params.id,
        spaceId: params.params.spaceId,
      },
      query: {
        resourceId: params.query.resourceId,
        resourceLanguage: params.query.resourceLanguage,
        resourceKind: params.query.resourceKind,
      },
    },
  });

  if (response.error !== undefined) {
    throw new Error(response.error.message);
  }

  return response.data;
}
